import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import { wsGetAll } from 'services/WService';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

//reemplazando valores de iniciales en estado

export default function ModalPaymentBureau(props) {
  const PBureau = props.model;
  const { bPartner } = props;

  const [paymentTerms, setPaymentTerms] = useState([]);
  const [paymentSelect, setPaymentSelect] = useState({});

  async function listPaymentTerms() {
    let response = await wsGetAll('base/payment-term');
    if (response.success) setPaymentTerms(response.data);
  }

  useEffect(() => {
    if (PBureau.open) {
      listPaymentTerms();
      setPaymentSelect(PBureau);
    }
  }, [PBureau.open]);

  return (
    <Modal
      title="Término de pago"
      model={PBureau}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity={`base/business-partner/${bPartner.id}/payment-bureau`}
    >
      <FormControl fullWidth margin="normal" size="small">
        <InputLabel>Término de pago</InputLabel>
        <Select
          defaultValue={PBureau.base_payment_term_id || ''}
          inputProps={{
            name: 'base_payment_term_id'
          }}
        >
          {paymentTerms.map((item, i) => {
            return (
              <MenuItem
                value={item.id}
                key={i}
                onClick={() => {
                  if (item.GroupNum != '-1') {
                    setPaymentSelect(item);
                  } else {
                    setPaymentSelect({ GroupNum: '-1' });
                  }
                }}
              >
                {item.PymntGroup}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      {paymentSelect.GroupNum != '-1' ? (
        <TextField
          label="Línea crédito"
          type="number"
          name="creditLine"
          margin="normal"
          inputProps={{ min: 0 }}
          fullWidth
          defaultValue={!!PBureau ? PBureau.creditLine : ''}
          required
        />
      ) : undefined}
    </Modal>
  );
}
